import { CardTravel } from "@mui/icons-material";
import { Button, CircularProgress, Grid, Icon, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import LoginWrapper from "../../Components/LoginWrapper/LoginWrapper";
import { dashboardBackground } from "../../Themes/Images";
import classes from "./Dashboard.module.css";
import PlayerList from "../../Components/Dashboard/PlayerList";
import CurrencyList from "../../Components/Dashboard/CurrencyList";
import Cart from "../../Components/Dashboard/Cart";
import { LoginButton } from "../../Components";
import { useMutation, useQuery } from "@apollo/client";
import { GENERATE_NONCE, GET_PLAYER, VERIFY_WALLET } from "./Dashboard.schema";
import { useAuth } from "../../Utils.js/Auth/AuthDetails";
import { useWeb3 } from "../../Utils.js/Web3/Web3Provider";
import { getWalletTokens } from "../../web3/tmp";
import { ethers } from "ethers";
import ErrorAlert from "../../Components/ErrorAlert/ErrorAlert";

function Dashboard() {
    const { email, logout } = useAuth()
    const { walletBalance, account, connectedState } = useWeb3()
    const { data, refetch: refetchPlayer, loading: loadingPlayer } = useQuery(GET_PLAYER, {
        fetchPolicy: 'network-only',
    })
    const [tokensState, setTokensState] = useState({})
    const [generateNonce, { error, loading, data: dataNonce }] = useMutation(GENERATE_NONCE)
    const [verifyWallet, { error: errorVerify, loading: loadingVerify, data: dataVerify }] = useMutation(VERIFY_WALLET)


    const getTokens = async () => {
        try {
            //account =0xee425bbbec5e9bf4a59a1c19efff522ad8b7a47a
            const res = await getWalletTokens(account)
            setTokensState(res)
        } catch (error) {
            console.log("🚀 ~ file: Dashboard.js:30 ~ getTokens ~ error", error)

        }

    }


    const connectWallet = async () => {
        try {
            await generateNonce({
                variables: {
                    publicAddress: account
                },
            })
        } catch (error) {
            console.log("🚀 ~ file: Dashboard.js:30 ~ getTokens ~ error", error)

        }

    }

    const signWalletPublicAddress = async () => {
        try {
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner(account)
            const signature = await signer.signMessage(`Signing one-time nonce: ${dataNonce?.generateWalletNonce?.nonce}`)
            verifyWallet({
                variables: {
                    publicAddress: account,
                    signature: signature
                }
            })
        } catch (error) {
            console.log("🚀 ~ file: Dashboard.js:30 ~ getTokens ~ error", error)

        }

    }

    useEffect(() => {
        if (dataVerify?.verifyWallet) {
            refetchPlayer()
        }
    }, [dataVerify])

    useEffect(() => {
        if (dataNonce?.generateWalletNonce) {
            signWalletPublicAddress()
        }
    }, [dataNonce])

    useEffect(() => {
        if (account) {
            getTokens()
        }

    }, [account])


    let buttonProps = {
        title: "Connect Wallet",
        onPress: connectWallet
    }

    const renderItems = () => {
        if (tokensState?.items && tokensState?.items?.length === 0) {
            return <p className={classes.notFoundText}>No NFT Found</p>
        }
        if (tokensState?.items && tokensState?.items?.length > 0) {
            return tokensState.items.map((item, index) => (
                <Grid key={index} item xs={3} md={2.4} >
                    <Cart {...item} />
                </Grid>
            ))
        }
    }


    return (
        <LoginWrapper
            style={{
                justifyContent: "normal",
                alignItems: "normal",
                flexDirection: 'column'
            }}
            img={dashboardBackground}
        >
            <LoginButton
                style={{
                    marginTop: 32,
                    alignSelf: 'flex-end',
                    marginRight: 32,
                    width: 200
                }}
                title='Log Out'
                onPress={logout}
            />
            {loadingPlayer ?
                <>
                    <CircularProgress size={80} style={{ alignSelf: 'center', margin: 'auto' }} />
                </>

                :
                <div className={classes.bigContainer}>
                    <div style={{ flexDirection: 'row', display: 'flex', flex: 1, marginBottom: 32 }}>
                        <div className={classes.containerPlayer}>
                            <p className={classes.text}>Player Profile</p>
                            <PlayerList
                                style={{ borderRadius: "10px 10px 0px 0px" }}
                                showDivider={true}
                                name={email}
                            />
                            <PlayerList
                                name={data?.getPlayer?.displayName || ''}
                                showDivider={true}
                            />
                            {data?.getPlayer?.wallet ?
                                <PlayerList
                                    name={data?.getPlayer?.wallet?.publicAddress || ''}
                                    style={{ borderRadius: "0px 0px 10px 10px", wordBreak: 'break-all' }}
                                />
                                :
                                <LoginButton
                                    style={{
                                        marginTop: 32,
                                    }}
                                    {...buttonProps}
                                />
                            }

                        </div>
                        <div className={classes.containerCurrency}>
                            <p className={classes.text}>Currency</p>
                            <CurrencyList name={'ETH'} price={walletBalance} />
                            {/* <CurrencyList name={'DYP Tokens'} price={tokensState?.metaData?.total || 0} /> */}

                        </div>
                    </div>
                    <div className={classes.cartContainer}>
                        <Typography className={classes.text}>NFT CAWS list</Typography>
                        <Grid
                            container
                            spacing={4}
                        >

                            {renderItems()}
                        </Grid>
                    </div>
                </div>

            }
            <ErrorAlert error={connectedState?.error} />
        </LoginWrapper >
    );
}

export default Dashboard;
